"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBirdsColors = void 0;

var _material = require("@mui/material");

var useBirdsColors = function useBirdsColors(theme) {
  var _useTheme = (0, _material.useTheme)(),
      palette = _useTheme.palette;

  var themeColors = {
    chambray: {
      primary: palette.link.main,
      secondary: palette.teal.main
    },
    california: {
      primary: palette.orange.main,
      secondary: palette.secondary.main
    },
    red: {
      primary: palette.error.main,
      secondary: palette.yellow.sunflower
    },
    green: {
      primary: palette.green.fruitSalad,
      secondary: palette.yellow.sunflower
    }
  };
  return themeColors[theme];
};

exports.useBirdsColors = useBirdsColors;